import { makeAutoObservable } from "mobx";

export class AddressDTO {
  id: number
  readonly type?: string
  description?: string
  title?: string
  firstName: string
  middleInitial?: string
  surname: string
  companyName?: string = ''
  address1: string
  address2: string
  address3: string // city
  address4: string // county/state
  postCode: string
  country: string
  zone?: number
  phoneDay: string
  phoneEve?: string
  email?: string
  dps?: string
  live?: boolean
  inUse?: boolean
  readonly isBillingAddress?: boolean = false
  readonly fullAddress?: string = ''
  readonly fullAddressWithoutCountryOneLine?: string = ''
  readonly fullAddressOneLine?: string = ''
  readonly fullName?: string = ''

  constructor(data: {
    id: number,
    type?: string,
    description?: string,
    title?: string,
    firstName: string,
    middleInitial?: string,
    surname: string,
    companyName: string,
    address1: string,
    address2: string,
    address3: string,
    address4: string,
    postCode: string,
    country: string,
    zone: number,
    phoneDay: string,
    phoneEve: string,
    email: string,
    dps: string,
    live: boolean,
    inUse: boolean,
    isBillingAddress?: boolean,
    fullAddress?: string,
    fullAddressWithoutCountryOneLine?: string,
    fullAddressOneLine?: string,
    fullName?: string
  }) {
    this.id = data.id
    this.type = data.type
    this.description = data.description
    this.title = data.title
    this.firstName = data.firstName
    this.middleInitial = data.middleInitial
    this.surname = data.surname
    this.companyName = data.companyName
    this.address1 = data.address1
    this.address2 = data.address2
    this.address3 = data.address3
    this.address4 = data.address4
    this.postCode = data.postCode
    this.country = data.country
    this.zone = data.zone
    this.phoneDay = data.phoneDay
    this.phoneEve = data.phoneEve
    this.email = data.email
    this.dps = data.dps
    this.live = data.live
    this.inUse = data.inUse
    this.isBillingAddress = data.isBillingAddress
    this.fullAddress = data.fullAddress
    this.fullAddressWithoutCountryOneLine = data.fullAddressWithoutCountryOneLine
    this.fullAddressOneLine = data.fullAddressOneLine
    this.fullName = data.fullName
    makeAutoObservable(this)
  }
}